module.exports = __webpack_public_path__ + "static/media/spinner.1ad2b618.gif";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/spinner.gif
// module id = 1500
// module chunks = 0